import React, { useEffect, useRef, useState } from 'react';

export const SectionDescription = ({ description }) => {
    const ref = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const element = ref.current;
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                }
            },
            { threshold: 0.3 }
        );

        if (ref.current) {
            observer.observe(element);
        }

        return () => {
            if (element) observer.unobserve(element);
        };
    }, []);

    return (
        <section
            ref={ref}
            className={`section-description ${isVisible ? "visible" : ""}`}
        >
            {description}
        </section>
    );
};
